module.exports = __webpack_public_path__ + "img/vmais.e5dec0de.jpeg";